export enum OPTIMIZELY_FLAGS_ENUM {
  WISHLIST_ICON = 'guest_engagement_wishlist',
}
